// Roleta (decisões do Arthur, 13/10): 1 ficha = 1 giro, fichas só na Noxara Store Box. Prêmios presos ao personagem.
// Itens de equipamento sorteados ganham depois raridade pela tabela da Roleta (89% comum, 8,5% raro, 2% épico, 0,5% lendário).
// Chances (w em centésimos de %): propostas por mim, ordenadas pela força do prêmio no jogo.
/** a Roleta só gira com fichas (item da Noxara Store Box); 1 ficha = 1 giro */
export const ROULETTE_TOKEN = 19082;
/** Poção de Experiência: o boost de XP da roleta e das recompensas vira esta poção (cargas = minutos), usada quando o jogador quiser */
export const XP_POTION = 11372;
export const ROULETTE_PRICE = 25;      // Noxara Coins por ficha (10 × 2,5, decisão do Arthur em 14/10)
export const ROULETTE_PRICE10 = 225;   // 10 fichas

export type RouletteKind = 'xpboost' | 'mat1' | 'mat2' | 'stone' | 'cards' | 'gem' | 'coins' | 'addon' | 'mount' | 'vip' | 'set' | 'item';
export interface RoulettePrize {
  id: string; kind: RouletteKind; label: string;
  /** peso: centésimos de % (a soma de todos é 10.000 = 100%) */
  w: number;
  /** quantidade (minutos de boost, coins, dias de VIP) */
  amount?: number;
  /** itens possíveis (kind 'set': um deles, sorteado igualmente; kind 'item': o próprio item) */
  items?: number[];
  /** sprite mostrado na roleta para prêmios que não são item (PREY_CARD_ICON = imagem das prey wildcards) */
  icon: number;
  /** ainda não liberado (fica fora do sorteio e a chance volta para os materiais básicos) */
  pending?: boolean;
}

/** ícone especial: a roleta mostra a imagem das Prey Wildcards (não é um item) */
export const PREY_CARD_ICON = -1;

export const MOONSILVER = [53207, 53209, 53211, 53213, 53215, 53217, 53219, 53221, 53223, 53225, 53227];
export const BAG_YOU_DESIRE = 34109, PRIMAL_BAG = 39546, BAG_YOU_COVET = 43860, FERUMBRAS_HAT = 5903;

export const ROULETTE: RoulettePrize[] = [
  { id: 'boost30', kind: 'xpboost', amount: 30, w: 500, label: '+50% de XP por 30 min', icon: 11510 },
  { id: 'mat1', kind: 'mat1', w: 500, label: 'Materiais básicos de refine/tier', icon: 37109 },
  { id: 'cards', kind: 'cards', amount: 5, w: 450, label: '5 Prey Wildcards', icon: PREY_CARD_ICON },
  { id: 'boost60', kind: 'xpboost', amount: 60, w: 500, label: '+50% de XP por 60 min', icon: 11510 },
  { id: 'stone', kind: 'stone', amount: 1, w: 455, label: 'Pedra de proteção (refine)', icon: 37110 },
  { id: 'mat2', kind: 'mat2', w: 400, label: 'Pacote de materiais valiosos', icon: 37110 },
  { id: 'golden', kind: 'set', w: 450, label: 'Item Golden', icon: 3360, items: [3360, 3364, 3365, 3555] },
  { id: 'demon', kind: 'set', w: 450, label: 'Item Demon', icon: 3388, items: [3387, 3388, 3389, 3420, 50189] },
  { id: 'gnome', kind: 'set', w: 450, label: 'Item Gnome', icon: 27648, items: [27647, 27648, 27649, 27650, 27651] },
  { id: 'coins', kind: 'coins', amount: 50, w: 350, label: '50 Noxara Coins', icon: 22118 },
  { id: 'doll', kind: 'addon', w: 300, label: 'Addon Doll', icon: 2991 },
  { id: 'mount', kind: 'mount', w: 300, label: 'Montaria aleatória', icon: 12308 },
  { id: 'vip7', kind: 'vip', amount: 7, w: 300, label: 'VIP de 7 dias', icon: 14758 },
  { id: 'mutant', kind: 'set', w: 350, label: 'Item Mutant Bone', icon: 40593, items: [40593, 40595] },
  { id: 'eldritch', kind: 'set', w: 300, label: 'Item Eldritch', icon: 36663,
    items: [36656, 36657, 36659, 36661, 36663, 36664, 36666, 36667, 36668, 36670, 36671, 36672, 36673, 36674, 50169, 50266] },
  { id: 'cobra', kind: 'set', w: 300, label: 'Item Cobra', icon: 30397, items: [30393, 30394, 30395, 30396, 30397, 30398, 30399, 30400, 50167] },
  { id: 'naga', kind: 'set', w: 250, label: 'Item Naga', icon: 39155, items: [39155, 39156, 39157, 39159, 39160, 39162, 39163, 50160, 50262] },
  { id: 'falcon', kind: 'set', w: 200, label: 'Item Falcon', icon: 28719,
    items: [28714, 28715, 28716, 28717, 28718, 28719, 28720, 28721, 28722, 28723, 28724, 28725, 50161] },
  // gemas da Wheel (uma de cada tamanho; quanto maior, mais rara) — decisão do Arthur, 14/10
  { id: 'gem0', kind: 'gem', amount: 0, w: 300, label: 'Lesser Gem (Wheel)', icon: 44602 },
  { id: 'gem1', kind: 'gem', amount: 1, w: 120, label: 'Regular Gem (Wheel)', icon: 44603 },
  { id: 'gem2', kind: 'gem', amount: 2, w: 40, label: 'Greater Gem (Wheel)', icon: 44604 },
  // armas umbral: crude, normal e master (uma delas, sorteada)
  { id: 'umbral0', kind: 'set', w: 250, label: 'Item Crude Umbral', icon: 20064, items: [20064, 20067, 20070, 20073, 20076, 20079, 20082, 20085, 20088, 50163] },
  { id: 'umbral1', kind: 'set', w: 80, label: 'Item Umbral', icon: 20065, items: [20065, 20068, 20071, 20074, 20077, 20080, 20083, 20086, 20089, 50164] },
  { id: 'umbral2', kind: 'set', w: 15, label: 'Item Umbral Master', icon: 20066, items: [20066, 20069, 20072, 20075, 20078, 20081, 20084, 20087, 20090, 50165] },
  // itens avulsos: quanto mais forte, mais raro
  { id: 'yalmask', kind: 'item', w: 120, label: 'Yalahari Mask', icon: 8864, items: [8864] },
  { id: 'sbdark', kind: 'item', w: 120, label: 'Spellbook of Dark Mysteries', icon: 8090, items: [8090] },
  { id: 'yalarmor', kind: 'item', w: 110, label: 'Yalahari Armor', icon: 8862, items: [8862] },
  { id: 'royalrobe', kind: 'item', w: 100, label: 'Royal Scale Robe', icon: 11687, items: [11687] },
  { id: 'archer', kind: 'item', w: 100, label: "Master Archer's Armor", icon: 8060, items: [8060] },
  { id: 'boh', kind: 'item', w: 90, label: 'Boots of Haste', icon: 3079, items: [3079] },
  { id: 'ocrea', kind: 'item', w: 90, label: 'Depth Ocrea', icon: 13996, items: [13996] },
  { id: 'exotic', kind: 'item', w: 90, label: 'Exotic Legs', icon: 35516, items: [35516] },
  { id: 'prisarmor', kind: 'item', w: 80, label: 'Prismatic Armor', icon: 16110, items: [16110] },
  { id: 'prislegs', kind: 'item', w: 80, label: 'Prismatic Legs', icon: 16111, items: [16111] },
  { id: 'prishelm', kind: 'item', w: 70, label: 'Prismatic Helmet', icon: 16109, items: [16109] },
  { id: 'prisshield', kind: 'item', w: 70, label: 'Prismatic Shield', icon: 16116, items: [16116] },
  { id: 'whispers', kind: 'item', w: 70, label: 'Dark Whispers', icon: 29427, items: [29427] },
  // set de monk da faixa do level 100 (cada peça avulsa)
  { id: 'mwisdom', kind: 'item', w: 120, label: 'Legs of Wisdom (monk)', icon: 50187, items: [50187] },
  { id: 'mfootwraps', kind: 'item', w: 120, label: 'Yalahari Footwraps (monk)', icon: 50289, items: [50289] },
  { id: 'mdrachaku', kind: 'item', w: 110, label: 'Drachaku (monk)', icon: 10391, items: [10391] },
  { id: 'mmerudri', kind: 'item', w: 100, label: 'Merudri Scale Mail (monk)', icon: 50263, items: [50263] },
  { id: 'mjade', kind: 'item', w: 100, label: 'Jade Conical Hat (monk)', icon: 50193, items: [50193] },
  { id: 'hat', kind: 'item', w: 200, label: "Ferumbras' Hat", icon: FERUMBRAS_HAT, items: [FERUMBRAS_HAT] },
  { id: 'vip30', kind: 'vip', amount: 30, w: 150, label: 'VIP de 30 dias', icon: 14758 },
  { id: 'desire', kind: 'item', w: 120, label: 'Bag You Desire', icon: BAG_YOU_DESIRE, items: [BAG_YOU_DESIRE] },
  { id: 'primal', kind: 'item', w: 100, label: 'Primal Bag', icon: PRIMAL_BAG, items: [PRIMAL_BAG] },
  { id: 'covet', kind: 'item', w: 70, label: 'Bag You Covet', icon: BAG_YOU_COVET, items: [BAG_YOU_COVET] },
  { id: 'moon', kind: 'set', w: 10, label: 'Item Moonsilver', icon: 53211, items: MOONSILVER },
];

/** materiais: básico = 3 fragmentos de pedra de proteção ou 50 dust; pacote = 1 pedra de proteção completa e 1 exalted core */
export const MAT1 = { fragments: 3, dust: 50 };
export const MAT2 = { stones: 1, cores: 1 };

/** prêmios que entram no sorteio agora (os pendentes devolvem a chance aos materiais básicos) */
export function rouletteActive(): RoulettePrize[] {
  const off = ROULETTE.filter((p) => p.pending).reduce((t, p) => t + p.w, 0);
  return ROULETTE.filter((p) => !p.pending).map((p) => (p.id === 'mat1' ? { ...p, w: p.w + off } : p));
}

export function rollRoulette(rnd = Math.random): RoulettePrize {
  const list = rouletteActive();
  const total = list.reduce((t, p) => t + p.w, 0);
  let r = rnd() * total;
  for (const p of list) { r -= p.w; if (r <= 0) return p; }
  return list[0]!;
}

/** Conteúdo das bags (reward_bags.lua do Canary: pesos relativos oficiais). Usar a bag dá um item. */
export const REWARD_BAGS: Record<number, { name: string; items: Array<[number, number]> }> = {
  [BAG_YOU_DESIRE]: { name: 'Bag You Desire', items: [
    [34082, 0.05], [34083, 0.01], [34084, 0.05], [34085, 0.01], [34086, 0.05], [34087, 0.05], [34097, 0.05], [34099, 0.05], [34088, 0.01],
    [34089, 0.05], [34094, 0.05], [34098, 0.05], [34090, 0.01], [34092, 0.05], [34095, 0.05], [34091, 0.01], [34093, 0.05], [34096, 0.05],
    [50254, 0.05], [50240, 0.05], [50159, 0.01]] },
  [PRIMAL_BAG]: { name: 'Primal Bag', items: [
    [39147, 0.01], [39148, 0.01], [39177, 0.05], [39149, 0.01], [39150, 0.05], [39180, 0.05], [39151, 0.05], [39152, 0.05], [39183, 0.05],
    [39153, 0.05], [39154, 0.05], [39186, 0.05], [50149, 0.05], [50188, 0.01]] },
  [BAG_YOU_COVET]: { name: 'Bag You Covet', items: [
    [43864, 0.05], [43866, 0.05], [43868, 0.05], [43870, 0.02], [43872, 0.05], [43874, 0.05], [43876, 0.02], [43877, 0.01], [43879, 0.05],
    [43881, 0.02], [43882, 0.02], [43884, 0.05], [43885, 0.02], [43887, 0.05], [43865, 0.00001], [43867, 0.00001], [43869, 0.00001],
    [43871, 0.00001], [43873, 0.00001], [43875, 0.00001], [43878, 0.00001], [43880, 0.00001], [43883, 0.00001], [43886, 0.00001],
    [50146, 0.02], [50157, 0.02]] },
};
export function rollBag(bagId: number, rnd = Math.random): number | undefined {
  const b = REWARD_BAGS[bagId]; if (!b) return undefined;
  const total = b.items.reduce((t, [, w]) => t + w, 0);
  let r = rnd() * total;
  for (const [id, w] of b.items) { r -= w; if (r <= 0) return id; }
  return b.items[0]![0];
}
